import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { InterstitialStep } from 'pages/find-my-classes/components/Quiz/components/InterstitialStep'
import { PersonalizedImage } from './components'

export const FullAccess = () => {
  const { t } = useTranslation('@mc/next')

  const badge = t('findMyClasses.infoBadge')
  const title = t('findMyClasses.fullAccess.title', {
    numInstructors: getNumberOfInstructors(),
  })

  return (
    <InterstitialStep title={title} badge={badge}>
      <PersonalizedImage />
    </InterstitialStep>
  )
}
